import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import { SN } from '@acme/core'
import { Checkbox } from '@mui/material'
import { hasPermission } from 'hooks/useBackendMenu'
import React from 'react'
import { rubrica } from 'service/api'
import { toast } from 'sonner'

const ExportarRubrica: React.FC<GridCellParams<SN>> = ({ value, id }) => {
    const { mutate } = rubrica.mutations.useUpdate({
        invalidateQuery: true,
        onSuccess: () => {
            toast.success('Rubrica atualizada com sucesso')
        },
        onError: e => {
            toast.error('Erro ao atualizar rubrica: ' + e.message)
        },
    })

    function exportarRubrica(event: React.ChangeEvent<HTMLInputElement>) {
        mutate({
            id: id as number,
            exportar: event.target.checked ? 'S' : 'N',
        })
    }

    return (
        <Checkbox
            checked={SN.isTrue(value)}
            onChange={exportarRubrica}
            disabled={!hasPermission(['update', 'Rubricas'])}
        />
    )
}

export default ExportarRubrica
